import Nav from "react-bootstrap/Nav";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHamburger,
  faNavicon,
  faToggleOn,
} from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";

const Header = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div>
        <div
          className="col-12 border border-0 border-bottom border-light p-3"
          style={{ background: "rgb(44, 44, 44)" }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <img src="/images/logo.png" width="140px" height="80px" alt="" />
            </div>
            <div>
              <Nav className="text-lowercase text-dark d-lg-flex d-none">
                <Nav.Link>Home</Nav.Link>
                <Nav.Link>Apps</Nav.Link>
                <Nav.Link>Designs</Nav.Link>
                <Nav.Link>Training</Nav.Link>
                <Nav.Link>Request Quote</Nav.Link>
                <Nav.Link>About</Nav.Link>
              </Nav>
              <Nav.Item
                className="text-white d-lg-none d-block px-4"
                style={{ cursor: "pointer" }}
                onClick={handleShow}
              >
                <h3>
                  <FontAwesomeIcon icon={faNavicon} />
                </h3>
              </Nav.Item>
            </div>
          </div>
        </div>
        <Offcanvas show={show} onHide={handleClose}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Pseudo Menu</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="text-lowercase text-dark d-block">
              <Nav.Link>Home</Nav.Link>
              <Nav.Link>Apps</Nav.Link>
              <Nav.Link>Designs</Nav.Link>
              <Nav.Link>Training</Nav.Link>
              <Nav.Link>Request Quote</Nav.Link>
              <Nav.Link>About</Nav.Link>
            </Nav>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};

export default Header;
